module.exports = "<div class=\"container-fluid \">\r\n</div>\r\n\r\n<div>\r\n\t<!-- <div class=\"loader\"></div> -->\r\n\t<!-- <div [ngBusy]=\"{busy: isLoading, message: 'Loading...', backdrop: false, delay: 10, minDuration: 10}\"></div> -->\r\n\t<echexpayment-menuitems></echexpayment-menuitems>\r\n</div>\r\n\r\n<div>\r\n\t<span defaultOverlayTarget></span>\r\n\t<router-outlet></router-outlet>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main